import { Typography } from '@mui/material';

import type { RouteInfo } from 'appTypes';
import { RouteSignature } from 'features/workflow_routemonitoring/RouteSignature';

import styles from '../Map.module.css';

interface IMapRouteTooltip {
  route?: Partial<RouteInfo> & {
    properties: RouteInfo['properties'] & {
      name?: string;
    };
  };
}

export function MapRouteTooltip({ route }: IMapRouteTooltip) {
  if (!route?.properties) return null;
  const { name, cardinal_direction, route_length } = route.properties;
  return (
    <div
      className={styles.map_tooltip_container}
      id={styles.map_tooltip_monitor}
    >
      <Typography variant="body2">{name}</Typography>
      <RouteSignature
        cardinal_direction={cardinal_direction}
        route_length={route_length}
      />
    </div>
  );
}
